import { atom } from 'recoil';
import { StructureSet } from '~/domain/patient/structureset';

export type DetachedContourResult =
    | { readonly kind: 'ready'; readonly structureSet: StructureSet }
    | {
          readonly kind: 'failed';
          readonly messageId: string;
          // The backend's or the reader's own words, shown after the reason.
          readonly detail?: string;
      };

// Held outside the patient: never listed, saved or exported.
export const detachedContourResultsState = atom<
    Readonly<Record<string, DetachedContourResult>>
>({
    key: 'detachedContourResults',
    default: {},
    // Holds domain objects, which a deep freeze would break.
    dangerouslyAllowMutability: true,
});
